/**
 * Shared helpers for Metrics tabs — date range defaults, number formatting.
 */

export function defaultDateRange(days: number): { start: string; end: string } {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - days);
  return {
    start: toISODate(start),
    end: toISODate(end),
  };
}

export function toISODate(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function fmt(n: number): string {
  return n.toLocaleString("en-US");
}

export function pct(n: number): string {
  return `${(n * 100).toFixed(1)}%`;
}

export function fmtBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export function fmtCurrency(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}
